import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../PropTypes/StoreProptypes";

interface PropTypes {
  userid: number | null; // user id
  children: React.ReactElement<any, any>; // children element
}

// component to protect routes if user not logged in
const ProtectedRoute = ({ userid, children }: PropTypes) => {
   const { currentUserStatus, user, is2FAVerified, isUserDeleted } = useSelector((store: StoreProptypes) => store);
  // check if user Id not exists
  if (!userid || (user?.is_google2fa_enabled === 1 && !is2FAVerified)) {
    if (!isUserDeleted) {
      return (
        <Navigate
          to={`/front/login?logout=true${
            currentUserStatus.currentUserType === 5
              ? "&app=readwritemadesimple"
              : ""
          }`}
          replace
        />
      );
    }
  }

  return children;
};

export default ProtectedRoute;
